<ion-badge [color]="color" *ngIf="label">{{label}}</ion-badge>
